import React, { useEffect } from "react"
import TableView, { formatterRowComponent } from "../../../../../component/atoms/Tabel/index.jsx"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { Badge, Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { ApproveSvgIcon } from "../../../../../component/atoms/Icons/SVG/index.jsx"
import { getAreaPendingList } from "../../../../../redux/actions/AreaAction.jsx"
import { useDispatch, useSelector } from "react-redux"
import { sortCaret } from "../../../../../_metronic/_helpers/index.js"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { linkWithCtrl } from "../../../../helpers/Utils.js"
import { stringFormatting, toThousandConvert } from "../../../../helpers/TextHelper.js"
import { EmptyCard, TableSkeleton } from "../../../../../component/index.jsx"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { AREA } from "../../../../../constants/InitTypeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { LABELING_CONST, ROUTING_STATUS } from "../../../../../constants/StringConstant.js"
import SVG from "react-inlinesvg"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"

export const AreaListPending = ({
  data,
  general,
  changePage,
  history,
  initialFilterTable,
  initialValue,
  isActiveSearch,
  isFilter
}) => {
  const dispatch = useDispatch()
  const privileges = loadUserLogin().privilege
  const { t } = useTranslation()
  const { General } = useSelector((state) => state)

  const uiCode = (e) => {
    return (
      <>
        <div className="d-flex align-items-start mb-1">
          <p className="text-dark font-weight-bolder font-size-lg mb-0">{stringFormatting(e.area_code)}</p>
          {e?.area_status === LABELING_CONST.FREEZE && (
            <SVG src={ICON_CONSTANTS.FREEZE_STATUS} className="ml-2" />
          )}
          {e?.area_status === LABELING_CONST.BLACKLIST && (
            <SVG src={ICON_CONSTANTS.BLACKLIST_STATUS} className="ml-2" />
          )}
        </div>
      </>
    )
  }
  const uiMitra = (e) => {
    return (
      <>
        <div className="d-flex align-items-start mb-1">
          <p className="text-dark font-weight-bolder font-size-lg mb-0">{stringFormatting(e.mitra_name)}</p>
          {e?.mitra_status === LABELING_CONST.FREEZE && (
            <SVG src={ICON_CONSTANTS.FREEZE_STATUS} className="ml-2" />
          )}
          {e?.mitra_status === LABELING_CONST.BLACKLIST && (
            <SVG src={ICON_CONSTANTS.BLACKLIST_STATUS} className="ml-2" />
          )}
        </div>
        <span className="text-muted font-weight-bold d-block">{stringFormatting(e.mitra_phone)}</span>
      </>
    )
  }
  const uiName = (e) => {
    return (
      <>
        <div className="d-flex align-items-start mb-1">
          <p className="text-dark font-weight-bolder font-size-lg mb-0">{stringFormatting(e.farmer_name)}</p>
          {e?.farmer_status === LABELING_CONST.FREEZE && (
            <SVG src={ICON_CONSTANTS.FREEZE_STATUS} className="ml-2" />
          )}
          {e?.farmer_status === LABELING_CONST.BLACKLIST && (
            <SVG src={ICON_CONSTANTS.BLACKLIST_STATUS} className="ml-2" />
          )}
        </div>
        <span className="text-muted font-weight-bold d-block">{stringFormatting(e.farmer_phone)}</span>
      </>
    )
  }
  const uiLuas = (e) => {
    return (
      <>
        <span>{toThousandConvert(e.area_land) ?? "-"}</span>
      </>
    )
  }
  const uiStatus = (e) => {
    return <Badge variant="warning">{e.status}</Badge>
  }
  const uiAction = () => {
    return (
      <>
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_AREA_PENDING) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Approval</Tooltip>}>
            <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
              <ApproveSvgIcon />
            </div>
          </OverlayTrigger>
        )}
      </>
    )
  }

  const uiDate = (e) => {
    return (
      <>
        <div className="mb-1">{e.submitted_date ? e.submitted_date : "-"}</div>
        <div>{e.submitted_time ? e.submitted_time : "-"}</div>
      </>
    )
  }

  const headerLuas = (
    <>
      {t("table_header_land_area_only")} (<span className={"text-lowercase"}>m</span>
      <sup>2</sup>)
    </>
  )

  useEffect(() => {
    if (General.isFinishUpdateOrDelete && General.actionInitType === AREA.UPDATE_STATUS) {
      let param = {
        ...initialFilterTable,
        ...initialValue
      }
      dispatch(getAreaPendingList({ pageReq: param }))
    }
  }, [General])

  const columns = [
    {
      dataField: "area_code",
      text: t("table_header_area_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      }
    },
    {
      dataField: "farmer.account.name",
      text: t("table_header_mitra"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          ...initialValue,
          sort: field + "," + order
        }
        dispatch(getAreaPendingList({ pageReq: param }))
      }
    },
    {
      dataField: "farmer.name",
      text: t("table_header_farmer"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiName
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          ...initialValue,
          sort: field + "," + order
        }
        dispatch(getAreaPendingList({ pageReq: param }))
      }
    },
    {
      dataField: "landArea,",
      text: headerLuas,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiLuas
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          ...initialValue,
          sort: field + "," + order
        }
        dispatch(getAreaPendingList({ pageReq: param }))
      }
    },
    {
      dataField: "status",
      text: t("table_header_status_area"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiStatus
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_submitted_date"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiDate
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          ...initialValue,
          sort: field + "," + order
        }
        dispatch(getAreaPendingList({ pageReq: param }))
      }
    },
    {
      dataField: "action",
      text: "ACTION",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction,
      }
    }
  ]

  return (
    <>
      <Card className="card-shadowless">
        <CardBody>
          {General.loading ? (
            <TableSkeleton column={7} row={10} />
          ) : data?.pageData?.length == 0 ? (
            <EmptyCard
              body={
                isFilter || isActiveSearch
                  ? t("messages_response_data_not_found")
                  : t("messages_response_empty_state", { name: "lahan" })
              }
            />
          ) : (
            ""
          )}
          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            dataTable={data.pageData}
            currentPage={data.page.currentPage}
            currentElement={data.page.currentElement}
            totalCount={data.page.totalCount}
            loadingGetData={general.loading}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (privileges.indexOf(PRIVILEGE_ENUM.DETAIL_AREA_PENDING) > -1) {
                  const url = RoutesConstants.AREA.DETAIL_AREA(ROUTING_STATUS.STATUS_STRING.PENDING, row.area_id)
                  if (e.ctrlKey) {
                    linkWithCtrl(url)
                  } else {
                    history.push(url)
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}